export const ONBOARDING_PICTURES = {
  parent: 'onboardring/pictures/parent-update-4x.png',
  student: 'onboardring/pictures/student-update-4x.png',
  teacher: 'onboardring/pictures/teacher-update-4x.png',
  exit: 'onboarding/icons/exit.svg',
  exitWhite: 'onboarding/icons/exit_white.svg',
  avatarGroupPhoto: 'onboarding/pictures/avatar-group-photo.png',
  other: 'onboardring/pictures/other-update-4x.png',
  philosophy: 'onboarding/pictures/philosophy-v2.png',
}

export const PAGES = {
  accountType: 'account-type',
  birthyear: 'birthyear',
  details: 'details',
  mathLevel: 'math-level',
  mappingQuiz: 'mapping-quiz',
  verifyMail: 'verify-mail',
  emailVerify: 'email-verify',
  avatar: 'avatar',
  philosophy: 'philosophy',
  wantToDo: 'want-to-do',
  selectGrade: 'select-grade',
}

export enum FriggPages {
  FRIGG1 = 'frigg1',
  FRIGG2 = 'frigg2',
  FRIGG3 = 'frigg3',
}
